import LogoYellowNightBottom from "./LogoYellowNightBottom";

export default function FooterMoretti() {
  return (
    <footer className="text-center border-t border-gray-300 px-5 py-8  ">
      <div className="flex justify-center">
        <div className="w-[250px] sm:w-[350px] md:w-[468px] max-w-full">
          <LogoYellowNightBottom />
        </div>
      </div>

      <p className="text-sm sm:text-base text-black px-4">
        Moretti Ugo | Via G. Donizetti, 21 – 61033 Fermignano (PU) – T. +39 0722 330852 
      </p>

      <div className="pt-4">
       <a href="https://binario01.com" target="_blank">
          <img src="/logoBinario.png" alt="Binario01" className="mt-4 h-4 mx-auto" />
          </a>
     
      </div>
    </footer>
  );
} 
